module.exports = __webpack_public_path__ + "37ba7b92/img/arrow-left-icon.785c715c.svg";